import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ProjectCategoryService from "../../../services/ProjectCategoryService";
import Breadcrumb from "../../../components/Breadcrumb";
import ListProjectCategories from "../Components/ListProjectCategories";
import MessageDialog from "../../../components/MessageDialog";

export default function ViewProjectCategories() {
  const [categories, setCategories] = useState([]);
  const [selected, setSelected] = useState(null); //  RADIO (single select)
  const [searchText, setSearchText] = useState(""); //  SEARCH
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [loading, setLoading] = useState(true);
  // const messageTimer = useRef(null);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const navigate = useNavigate();

  useEffect(() => {
    fetchCategories();
  }, [currentPage]);


  const fetchCategories = async () => {
    setLoading(true);
    try {
      const res = await ProjectCategoryService.getAll(currentPage, itemsPerPage);
      setCategories(res.data || []);
      setPageCount(res.totalPages || 0);
    } catch (err) {
      console.error(err);
      showMessage("Error loading categories");
    } finally {
      setLoading(false);
    }
  };





  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  // 🔹 RADIO SELECT
  const handleSelect = (id) => {
    setSelected(id);
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };


  const handleAdd = () => {
    localStorage.removeItem("editCategory");
    navigate("/cpnl/categories/add");
  };

  const handleModify = () => {
    if (!selected) {
      showMessage("Select one record to modify.");
      return;
    }
    navigate(`/cpnl/categories/add/${selected}`);
  };

  const handleToggleStatus = async (cat) => {
    const newStatus = cat.status === "Active" ? "Inactive" : "Active";
    const confirmMsg = `Are you sure do you want to change status as ${newStatus}?`;

    if (!window.confirm(confirmMsg)) return;

    setLoading(true);
    try {
      await ProjectCategoryService.delete(cat.id, {
        categoryName: cat.categoryName,
        categoryCode: cat.categoryCode,
        status: newStatus,
        isActive: newStatus === "Active" ? 1 : 0,
        updatedBy: 1,
      });
      showMessage(`Project Category status changed to ${newStatus}.`, "success");
      fetchCategories();
    } catch (err) {
      console.error(err);
      showMessage("Error updating status", "error");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 FRONTEND SEARCH FILTER
  const filteredCategories = categories.filter(
    (cat) =>
      cat.categoryName.toLowerCase().includes(searchText.toLowerCase()) ||
      cat.categoryCode.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <>
      <Breadcrumb pageTitle="Project Categories" secondTitle="Masters" />

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">

          {/* {message && (
            <div
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                } d-flex justify-content-between align-items-center w-100 mb-2 p-2`}
            >
              <span>{message}</span>
              <button type="button" className="btn-close" onClick={closeMessage}></button>
            </div>
          )} */}

          
            <MessageDialog
              message={message}
              type={msgType}
              setMessage={setMessage}
              setMsgType={setMsgType}
            />
          
          {/* 🔹 SEARCH + ADD / MODIFY */}
          <div className="mb-3 pb-2 border-bottom d-flex align-items-end gap-3">
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search Category"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>

            <div className="ms-auto d-flex gap-2">
              <button
                className="d-inline-flex btn btn-success"
                onClick={handleAdd}
                disabled={loading}
              >
                <i className="ti ti-plus me-1"></i> Add
              </button>

              <button
                className="d-inline-flex btn btn-warning"
                onClick={handleModify}
                disabled={loading}
              >
                <i className="ti ti-pencil me-1"></i> Modify
              </button>
            </div>
          </div>

          {/* 🔹 TABLE */}
          <ListProjectCategories
            loading={loading}
            filteredCategories={filteredCategories}
            selected={selected}
            handleSelect={handleSelect}
            handleToggleStatus={handleToggleStatus}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
          />

        </div>
      </div>
    </>
  );
}
